const UBPECoordinates = [
  // ID Barranco: V1-D-51119483
  [
    [-77.01945036099994, -12.130597354999963],
    [-77.01914848599995, -12.131269479999958],
    [-77.01799998699994, -12.131246104999889],
    [-77.01787298599999, -12.135763604999852],
    [-77.01384573599995, -12.13924610499987],
    [-77.0124863609999, -12.14043160499989],
    [-77.01260336099989, -12.140603479999982],
    [-77.01342386099992, -12.14227735499992],
    [-77.01382423699994, -12.143087854999862],
    [-77.01391998599996, -12.143259729999954],
    [-77.01409573699993, -12.1436972299999],
    [-77.01417961099992, -12.143863229999965],
    [-77.01388673599996, -12.14411322999996],
    [-77.01568948599999, -12.146505854999873],
    [-77.01519923599994, -12.147097604999885],
    [-77.01575198599994, -12.147089854999876],
    [-77.01576173599994, -12.147191354999904],
    [-77.01583011199989, -12.147287104999918],
    [-77.01595898599999, -12.147357479999812],
    [-77.01702536099992, -12.149718729999961],
    [-77.01735548599999, -12.150515729999825],
    [-77.0183516109999, -12.152628854999875],
    [-77.01715036199988, -12.153449229999978],
    [-77.01682811199998, -12.153685604999907],
    [-77.01635161099989, -12.154070229999945],
    [-77.01558398599997, -12.154734354999903],
    [-77.01584761099991, -12.155109354999922],
    [-77.0160351109999, -12.155628854999918],
    [-77.01678511099988, -12.155206979999946],
    [-77.01926361199997, -12.153871104999894],
    [-77.01946173599998, -12.154048854999928],
    [-77.01948511099988, -12.154318104999845],
    [-77.01949236099995, -12.15440135499989],
    [-77.01953361099999, -12.15471835499983],
    [-77.01953823599996, -12.15475385499991],
    [-77.0199061109999, -12.154968479999923],
    [-77.02289648699997, -12.156267604999925],
    [-77.02430661199986, -12.156822354999917],
    [-77.0250273609999, -12.157040979999977],
    [-77.02630861099993, -12.157306604999917],
    [-77.02631261099992, -12.157152354999937],
    [-77.02632423699998, -12.15699410499991],
    [-77.02633011099994, -12.156906229999947],
    [-77.02635161099994, -12.156726604999903],
    [-77.02638473599995, -12.156540979999932],
    [-77.02641798599996, -12.156384729999957],
    [-77.0264433619999, -12.156203104999918],
    [-77.02644711099992, -12.156140604999905],
    [-77.0264433609999, -12.155915979999975],
    [-77.02642973599995, -12.155792979999944],
    [-77.02666986199989, -12.155800729999953],
    [-77.02667773699994, -12.155720729999814],
    [-77.02555073599996, -12.155566354999905],
    [-77.02534573599996, -12.155540854999913],
    [-77.02529886099995, -12.155445354999927],
    [-77.02522848699994, -12.155236354999943],
    [-77.02517973599998, -12.155121104999921],
    [-77.02513861099993, -12.155019479999964],
    [-77.02510548599997, -12.154906229999938],
    [-77.02508986099991, -12.154837854999926],
    [-77.02508786099992, -12.154775354999913],
    [-77.02507223599997, -12.15465235499994],
    [-77.02505473599996, -12.154478479999966],
    [-77.02505673599995, -12.15436722999982],
    [-77.0250448619999, -12.154273479999972],
    [-77.02503323599996, -12.154193354999904],
    [-77.02501173599995, -12.154093729999943],
    [-77.02497461099995, -12.153976604999912],
    [-77.02496286099989, -12.1538769799999],
    [-77.02493748699999, -12.153779229999941],
    [-77.02492973599988, -12.153695229999926],
    [-77.02490623599994, -12.153564479999943],
    [-77.02488873699997, -12.153484354999932],
    [-77.02492386199992, -12.153289104999942],
    [-77.02492386099993, -12.153193354999928],
    [-77.02489261099993, -12.1530918549999],
    [-77.02488286199991, -12.153025354999897],
    [-77.02489848699997, -12.152962854999885],
    [-77.02494723699994, -12.152878854999926],
    [-77.0249726109999, -12.152771479999956],
    [-77.02499223599995, -12.152644479999935],
    [-77.02501948599996, -12.152531229999965],
    [-77.02510948599996, -12.152464854999891],
    [-77.02513286099992, -12.152302729999974],
    [-77.02520111099989, -12.152216854999892],
    [-77.02521486199987, -12.152117229999817],
    [-77.0252538609999, -12.152021479999974],
    [-77.02530473599995, -12.1519551049999],
    [-77.02550198599982, -12.151994104999915],
    [-77.02552736099994, -12.151921854999898],
    [-77.02498823599996, -12.151806604999877],
    [-77.02479298699996, -12.151765604999923],
    [-77.02478323599996, -12.151656229999958],
    [-77.0247871119999, -12.151539104999927],
    [-77.02478711099991, -12.151474604999919],
    [-77.0247773609999, -12.151376979999952],
    [-77.02476761199989, -12.1513144799999],
    [-77.0247461109999, -12.151208979999979],
    [-77.02472661099995, -12.1511328549999],
    [-77.02471673599996, -12.151042979999943],
    [-77.02471098599995, -12.1509804799999],
    [-77.02472073599995, -12.15091597999998],
    [-77.02477923599997, -12.15082623],
    [-77.02482623699996, -12.150726604999932],
    [-77.02483786099992, -12.150537104999898],
    [-77.02487886099993, -12.15048822999995],
    [-77.02492186199999, -12.150400354999874],
    [-77.02493748599994, -12.150324229999967],
    [-77.02491986099989, -12.149806604999924],
    [-77.02491798599982, -12.149679729999946],
    [-77.02492386099993, -12.149558604999925],
    [-77.02494936199992, -12.149406229999954],
    [-77.02497661099994, -12.149290979999932],
    [-77.02499798699995, -12.149187479999966],
    [-77.02501948599996, -12.149121104999892],
    [-77.02503323599996, -12.149052729999937],
    [-77.02509761099992, -12.14867972999997],
    [-77.02511136099992, -12.148470729999929],
    [-77.02515823699997, -12.14837110499991],
    [-77.02519723599994, -12.148320354999896],
    [-77.02524611199988, -12.14823635499988],
    [-77.02527936099995, -12.14814648],
    [-77.02531048599997, -12.147976479999954],
    [-77.02533786099991, -12.147876979999978],
    [-77.02542386099992, -12.147687479999945],
    [-77.02548423599995, -12.147595729999978],
    [-77.02554098699994, -12.147484354999904],
    [-77.02560936099991, -12.147324229999981],
    [-77.02564648599997, -12.147218729999963],
    [-77.02569723699997, -12.147126979999939],
    [-77.02573436099993, -12.147070354999926],
    [-77.02578323699998, -12.146980479999968],
    [-77.02583598599995, -12.146890604999896],
    [-77.02586523599996, -12.146841854999934],
    [-77.02592186099992, -12.14676173],
    [-77.02597661099992, -12.146699229999967],
    [-77.02603911099993, -12.146587729999965],
    [-77.02606248599994, -12.146529354999927],
    [-77.02609948599996, -12.146406229999968],
    [-77.02622073599997, -12.146283229999938],
    [-77.02633398699999, -12.146087854999905],
    [-77.02640236099995, -12.145990229999938],
    [-77.0264648619999, -12.14590623],
    [-77.02655286099997, -12.145816354999909],
    [-77.02669923599996, -12.145744104999892],
    [-77.02680661099993, -12.145789104999892],
    [-77.02683198599993, -12.145716854999932],
    [-77.02613086199989, -12.145431604999885],
    [-77.0261093609999, -12.145359354999869],
    [-77.0260761109999, -12.145283229999961],
    [-77.02605473699998, -12.145222604999901],
    [-77.02599611099993, -12.145093729999928],
    [-77.02598636099992, -12.145021479999969],
    [-77.02601936199989, -12.144925729999954],
    [-77.02604298599982, -12.144777354999917],
    [-77.02604686099994, -12.144667979999952],
    [-77.02607611199988, -12.1445527299999],
    [-77.02621486099991, -12.144443354999908],
    [-77.02625198599998, -12.14439448],
    [-77.02629886199992, -12.14431060499993],
    [-77.02632623599999, -12.144242229999975],
    [-77.02634573599983, -12.144179729999962],
    [-77.02636723599983, -12.144126979999953],
    [-77.02640236099995, -12.144068354999888],
    [-77.02644136099991, -12.143996104999871],
    [-77.02649611099991, -12.143921854999917],
    [-77.02655661099993, -12.143876979999959],
    [-77.02663273599995, -12.14382423],
    [-77.02668948599995, -12.1437832299999],
    [-77.02673436099991, -12.143718729999932],
    [-77.02678123599998, -12.143615229999966],
    [-77.02683598599998, -12.143570354999895],
    [-77.02690436099994, -12.143519479999952],
    [-77.02694336199988, -12.143421854999872],
    [-77.0269843609999, -12.143246229999818],
    [-77.02705861099992, -12.143185604999928],
    [-77.02708798599997, -12.143117229999973],
    [-77.02710548599998, -12.143017604999898],
    [-77.02716598599994, -12.142978479999954],
    [-77.02724023599995, -12.1429277299999],
    [-77.0272948619999, -12.142878854999879],
    [-77.02734961099992, -12.142800729999976],
    [-77.02738473699998, -12.142755854999905],
    [-77.02746873599995, -12.14267972999994],
    [-77.02753911199989, -12.142626978999829],
    [-77.02757036199989, -12.142560604999915],
    [-77.02759961099991, -12.142468729999962],
    [-77.02764448599999, -12.142365104999897],
    [-77.02772261099994, -12.142322229999934],
    [-77.02776948599995, -12.142269479999982],
    [-77.02779886199988, -12.142187479999961],
    [-77.02782623599995, -12.142128854999896],
    [-77.02788861099992, -12.1421132299999],
    [-77.02795511099993, -12.14204885499987],
    [-77.02799411099994, -12.141935729999943],
    [-77.02802936099994, -12.141855479999947],
    [-77.0280761119999, -12.141804729999933],
    [-77.02810173599988, -12.141744104999873],
    [-77.0281211109999, -12.141679729999964],
    [-77.02820111199986, -12.141589729999964],
    [-77.02827536099994, -12.1415019799999],
    [-77.02832423699994, -12.14142573],
    [-77.0283788619999, -12.141374979999966],
    [-77.02842373599998, -12.141318354999896],
    [-77.02849223699997, -12.141222604999882],
    [-77.02851561099993, -12.141171854999868],
    [-77.02852923599994, -12.141117229999963],
    [-77.02857423599983, -12.141017604999888],
    [-77.02864261099995, -12.140976604999878],
    [-77.02869536099996, -12.140910104999875],
    [-77.02874611099992, -12.140812478999976],
    [-77.02877348599998, -12.140749979999953],
    [-77.02879686099993, -12.14067185499988],
    [-77.02880273599999, -12.14061523],
    [-77.02884573599988, -12.140554729999963],
    [-77.02890423599996, -12.140503854999906],
    [-77.02894136099991, -12.140455104999887],
    [-77.0289648609999, -12.14039847999993],
    [-77.02901361099993, -12.14033385499988],
    [-77.02909573599999, -12.140249979999965],
    [-77.02915623599995, -12.140197229999956],
    [-77.02921486099996, -12.14018360499989],
    [-77.02932036199991, -12.140140604999885],
    [-77.02943748599995, -12.140140604999885],
    [-77.02845311199991, -12.139706979999971],
    [-77.02830273699993, -12.139626979999946],
    [-77.02818948599997, -12.139548854999873],
    [-77.02793948599998, -12.139415979999967],
    [-77.02788861099992, -12.139316354999892],
    [-77.02776173599995, -12.139134729999967],
    [-77.02762498599998, -12.13896485499987],
    [-77.02747461099995, -12.1388066049999],
    [-77.02709961099993, -12.138466854999876],
    [-77.02681048599999, -12.138140604999876],
    [-77.02667973599995, -12.137962854999898],
    [-77.02656048699998, -12.137783229999968],
    [-77.02598436199992, -12.136773479999931],
    [-77.02591986099992, -12.136650354999858],
    [-77.02581448699993, -12.136503854999887],
    [-77.02568361099992, -12.136374979999971],
    [-77.02551173599994, -12.136240229999942],
    [-77.02541598599998, -12.136185604999866],
    [-77.0253183609999, -12.136136729999976],
    [-77.02521673599995, -12.136093728999981],
    [-77.02511136099992, -12.136060604999898],
    [-77.02500586199989, -12.136035104999848],
    [-77.02489448599994, -12.136019479999959],
    [-77.02467773699993, -12.135986354999886],
    [-77.02456836199991, -12.135964854999884],
    [-77.02424998599997, -12.135878854999874],
    [-77.02404298599998, -12.135806604999857],
    [-77.02299611099994, -12.13526760499991],
    [-77.02311523599997, -12.134933604999901],
    [-77.0225058609999, -12.134714854999856],
    [-77.02210348599993, -12.134460979999972],
    [-77.02169923599996, -12.134070354999892],
    [-77.02127148699998, -12.133445354999878],
    [-77.02115623599997, -12.133251854999969],
    [-77.0196121109999, -12.130669104999924],
    [-77.01948398699989, -12.1306122299999],
    [-77.01945036099994, -12.130597354999963]
  ],
  // ID San Borja: V1-D-51119515
  [
    [-76.98731636099996, -12.079939479999894],
    [-76.9842479859999, -12.083931604999975],
    [-76.98401298599998, -12.084732229999872],
    [-76.98394086099995, -12.084977979999962],
    [-76.98266948599996, -12.084780604999878],
    [-76.98169136199994, -12.084628854999949],
    [-76.98178323599996, -12.085099604999982],
    [-76.98169336099983, -12.086683604999962],
    [-76.98160548599992, -12.087118354999973],
    [-76.98125973599991, -12.088830104999943],
    [-76.98107448699994, -12.090141479999886],
    [-76.98061711099996, -12.093379228999936],
    [-76.98011623599996, -12.09692460499997],
    [-76.97931986099991, -12.102061354999933],
    [-76.97903361099992, -12.1042583549999],
    [-76.9781659869999, -12.11025585499982],
    [-76.97828498599989, -12.11026422999987],
    [-76.98280086099999, -12.110583104999876],
    [-76.9927477359999, -12.111286604999918],
    [-76.99361723699991, -12.111321604999887],
    [-77.00958598599993, -12.112384729999917],
    [-77.00977148599998, -12.110290979999888],
    [-77.00985936199999, -12.110246104999817],
    [-77.01039848599999, -12.1076074799999],
    [-77.01044136099989, -12.107277354999951],
    [-77.01062111099992, -12.106683604999944],
    [-77.01211323599995, -12.099111354999934],
    [-77.01100198599994, -12.095978479999872],
    [-77.00769536099989, -12.089892604999932],
    [-77.00759186099992, -12.08950585499997],
    [-77.00755473599997, -12.089271479999866],
    [-77.00754686099987, -12.088955104999968],
    [-77.00756536099988, -12.088826979999965],
    [-77.00756973599988, -12.088829479999958],
    [-77.00982973599992, -12.089158854999937],
    [-77.01001373599996, -12.087376979999874],
    [-77.01010736099988, -12.086728479999977],
    [-77.01009186099992, -12.086539104999929],
    [-77.01006048699992, -12.086277354999936],
    [-77.00998048699995, -12.08595310499993],
    [-77.00992573599996, -12.085535104999963],
    [-77.0099336109999, -12.084964854999953],
    [-77.00414061099991, -12.08407622899989],
    [-76.99910936099985, -12.083394479999981],
    [-76.99858198699991, -12.083193354999935],
    [-76.99821873699995, -12.083033229999899],
    [-76.99790823599994, -12.082863229999873],
    [-76.99730273599994, -12.082453104999956],
    [-76.99634373599997, -12.081855478999898],
    [-76.99583198599993, -12.08159572999989],
    [-76.99537111199999, -12.08143160499992],
    [-76.99353323599996, -12.081007854999939],
    [-76.99342573599995, -12.081712854999921],
    [-76.99295111099997, -12.081415979999974],
    [-76.99277936199996, -12.081699229999856],
    [-76.98977536099989, -12.081755854999926],
    [-76.9896016109999, -12.081730479999976],
    [-76.98731636099996, -12.079939479999894]
  ],
  // V1-D-119491 La Molina
  [
    [-76.94006448599998, -12.064048854999953],
    [-76.93942386099997, -12.064933604999908],
    [-76.93639286099994, -12.064091604999874],
    [-76.9361501109999, -12.064131479999958],
    [-76.93598411099987, -12.064156479999895],
    [-76.9358453609999, -12.064149604999955],
    [-76.93581523599994, -12.064152604999947],
    [-76.93570661099989, -12.06416322999985],
    [-76.93554523599988, -12.064229229999967],
    [-76.93534961099994, -12.06431335499991],
    [-76.93518348599997, -12.064315479999834],
    [-76.93514673599992, -12.0643112299999],
    [-76.93501073599998, -12.064295104999928],
    [-76.93476748599994, -12.064158729999917],
    [-76.93418686099994, -12.063801104999982],
    [-76.93341748599994, -12.063476603999959],
    [-76.93229486099995, -12.063187479999954],
    [-76.93086723599998, -12.063281229999973],
    [-76.92938911099998, -12.063999354999964],
    [-76.92861323599999, -12.064554979999912],
    [-76.92747348599994, -12.06528285499985],
    [-76.92689161099992, -12.065425104999974],
    [-76.92655886099999, -12.065506479999954],
    [-76.92618036099998, -12.06559897999989],
    [-76.92515561099998, -12.06531160499992],
    [-76.92458123599988, -12.065331228999923],
    [-76.92431273599988, -12.065340354999876],
    [-76.92422736099991, -12.06537435499996],
    [-76.92396948599998, -12.065477104999957],
    [-76.9230872359999, -12.065831229999901],
    [-76.92208786099991, -12.06605860499991],
    [-76.9215351119999, -12.066116104999935],
    [-76.92149961099994, -12.066106104999847],
    [-76.92128323599997, -12.066044978999912],
    [-76.92035936199989, -12.065374979999945],
    [-76.91918548599995, -12.063759729999958],
    [-76.9184218609999, -12.062703104999912],
    [-76.91747448599995, -12.06148885499988],
    [-76.91670898599995, -12.060517604999916],
    [-76.91472448599995, -12.05991760499984],
    [-76.91462886099987, -12.059880353999972],
    [-76.91371436099996, -12.059524729999907],
    [-76.91206811099988, -12.05950597999987],
    [-76.90989811199995, -12.059412479999878],
    [-76.90782161099992, -12.059375104999958],
    [-76.90591348699996, -12.059449979999954],
    [-76.9047773609999, -12.059554729999945],
    [-76.90343161099997, -12.059900354999911],
    [-76.90224023599995, -12.060285104999934],
    [-76.9011621109999, -12.060437479999962],
    [-76.8997773609999, -12.060015604999933],
    [-76.89860548599995, -12.059503854999889],
    [-76.89636911099984, -12.05890235499993],
    [-76.89189848599995, -12.058906104999892],
    [-76.88913323599996, -12.05935635499992],
    [-76.88963811099995, -12.06147135499998],
    [-76.88993436099997, -12.063087354999936],
    [-76.89009323599998, -12.063492604999965],
    [-76.89095786099995, -12.065699729999949],
    [-76.89111948599998, -12.067207979999978],
    [-76.89058073699988, -12.06955110499996],
    [-76.89045361199993, -12.070859729999938],
    [-76.89039223599991, -12.071490228999892],
    [-76.88988998599996, -12.0744499799999],
    [-76.88955736099996, -12.075449354999932],
    [-76.8887493609999, -12.075826354999947],
    [-76.88729498599997, -12.076203479999947],
    [-76.8861368609999, -12.076122479999924],
    [-76.88559823699995, -12.076364979999937],
    [-76.88538286199997, -12.077576979999947],
    [-76.88542973599994, -12.080101604999982],
    [-76.88540423599994, -12.08350972999989],
    [-76.88549636099992, -12.0842969799999],
    [-76.88580811099996, -12.08484572999987],
    [-76.88605261099997, -12.085045729999877],
    [-76.88621961099994, -12.085182478999911],
    [-76.88644411099995, -12.085506729999963],
    [-76.88644411099995, -12.085555979999924],
    [-76.88644411099995, -12.085831104999954],
    [-76.88628198599991, -12.086242479999953],
    [-76.88585798599996, -12.086778729999935],
    [-76.8851844859999, -12.087327479999942],
    [-76.88469336099996, -12.087818354999968],
    [-76.88432398599991, -12.088711854999929],
    [-76.88403711099983, -12.089410229999885],
    [-76.88403711099983, -12.089796853999815],
    [-76.88452473599995, -12.09055672999989],
    [-76.88488523599995, -12.091118729999948],
    [-76.88513461099996, -12.0917173549999],
    [-76.88582048599994, -12.092365854999912],
    [-76.88660623599992, -12.092515479999975],
    [-76.88757898599994, -12.092640229999972],
    [-76.88866086099995, -12.092692604999968],
    [-76.88912548599995, -12.092715104999968],
    [-76.89018548599995, -12.092727604999936],
    [-76.8908912359999, -12.093030729999953],
    [-76.89112886099997, -12.093132854999965],
    [-76.89140761099992, -12.0937377299999],
    [-76.89151986099989, -12.094672979999928],
    [-76.89154686099988, -12.095597729999895],
    [-76.89064448599993, -12.097013604999972],
    [-76.89003511099997, -12.098183604999974],
    [-76.88988861099995, -12.099158229999887],
    [-76.89013286099998, -12.100378854999974],
    [-76.89059573599997, -12.101574228999937],
    [-76.89166798599996, -12.10298822999988],
    [-76.89214261099988, -12.103453104999971],
    [-76.89423436099997, -12.105990229999918],
    [-76.89472711099995, -12.107668354999873],
    [-76.8953801109999, -12.109903854999914],
    [-76.89625386099988, -12.112583979999897],
    [-76.89738161099996, -12.114123229999961],
    [-76.89775123699997, -12.114248479999958],
    [-76.89811323599997, -12.114371103999872],
    [-76.90106011199993, -12.113528229999929],
    [-76.90124198599995, -12.113543979999918],
    [-76.9029533609999, -12.113690479999946],
    [-76.90387461099994, -12.114067354999975],
    [-76.90414361099988, -12.114177354999924],
    [-76.90565823599997, -12.115962479999837],
    [-76.90614511099994, -12.116821979999884],
    [-76.90657773599992, -12.117585354999903],
    [-76.90820061099998, -12.119586854999966],
    [-76.91063498599988, -12.122129229999814],
    [-76.91078198599996, -12.122333479999838],
    [-76.91163261099996, -12.121678354999972],
    [-76.9126778609999, -12.121227354999974],
    [-76.91435861099995, -12.121042854999814],
    [-76.9150351109999, -12.120673979999935],
    [-76.91646973599995, -12.11987460499995],
    [-76.91703048599999, -12.119603604999895],
    [-76.91815086199995, -12.119062354999812],
    [-76.91829386099988, -12.118993354999873],
    [-76.92017948599994, -12.118931854999914],
    [-76.92097886099998, -12.119095729999913],
    [-76.92173723599996, -12.119567228999927],
    [-76.92300798599996, -12.120386979999978],
    [-76.92438136199996, -12.12100198],
    [-76.92577498599991, -12.121596354999951],
    [-76.92839061199999, -12.1224999799999],
    [-76.92954498599988, -12.122917979999954],
    [-76.93106048699997, -12.123494104999963],
    [-76.93320523699998, -12.123755854999843],
    [-76.93503511099993, -12.123445354999888],
    [-76.93785161099993, -12.12246685499997],
    [-76.94079111099995, -12.122160854999947],
    [-76.94119086199998, -12.121512354999936],
    [-76.94152923599995, -12.121052229999975],
    [-76.94188998599992, -12.120993229999954],
    [-76.94247223599996, -12.120960479999837],
    [-76.94316123599998, -12.120760229999973],
    [-76.94374686099991, -12.120466979999946],
    [-76.94384973599989, -12.120325979999905],
    [-76.94425336099988, -12.119723979999947],
    [-76.94493011099996, -12.119192479999924],
    [-76.94569273599996, -12.118853479999927],
    [-76.94616698599998, -12.118823479999946],
    [-76.94669611199987, -12.11873335499996],
    [-76.94723636099997, -12.118361979999861],
    [-76.94759961099993, -12.117974229999845],
    [-76.94774611099996, -12.117535104999945],
    [-76.94808648699996, -12.115012354999976],
    [-76.94839298599993, -12.113525604999893],
    [-76.94857686099994, -12.112146354999936],
    [-76.94876073599988, -12.110935604999952],
    [-76.94908261099988, -12.109908729999972],
    [-76.94984898599995, -12.108759229999976],
    [-76.95038536099992, -12.107548354999892],
    [-76.9505846109999, -12.106536853999955],
    [-76.95076861099994, -12.105004229999963],
    [-76.95115173599993, -12.104391229999976],
    [-76.95204061099992, -12.103517604999979],
    [-76.95311348599989, -12.102122854999948],
    [-76.95404836099988, -12.100988729999926],
    [-76.95450823599998, -12.100360354999964],
    [-76.95555036199988, -12.0992874799999],
    [-76.95628611099994, -12.098720354999898],
    [-76.95726698599998, -12.0981226049999],
    [-76.95796873599988, -12.097324229999913],
    [-76.95824798699988, -12.095639729999903],
    [-76.9587536109999, -12.09424510499997],
    [-76.95909098599992, -12.09376310499988],
    [-76.95982648599994, -12.092712479999932],
    [-76.96030161099998, -12.090903854999908],
    [-76.96086873599995, -12.086474604999978],
    [-76.96088398599994, -12.08515647899992],
    [-76.96060348599991, -12.084246104999977],
    [-76.96007173699996, -12.08285747999986],
    [-76.95922873599994, -12.081662104999964],
    [-76.95732823599991, -12.079562353999961],
    [-76.95661948599997, -12.079104979999954],
    [-76.95603323699999, -12.078726604999929],
    [-76.95568148599989, -12.078439479999872],
    [-76.95551173699988, -12.078374979999978],
    [-76.95557036099996, -12.078003854999963],
    [-76.95575973599989, -12.077697229999842],
    [-76.9560917359999, -12.077287104999925],
    [-76.95638861099997, -12.076921854999966],
    [-76.95671673599998, -12.076562479999836],
    [-76.95705661099998, -12.076244104999944],
    [-76.95738861099994, -12.07604297999984],
    [-76.95794923599988, -12.07582047999989],
    [-76.9583124859999, -12.07594535499993],
    [-76.9592324869999, -12.075755854999954],
    [-76.96040236199997, -12.075706979999836],
    [-76.96189448599989, -12.076044979999892],
    [-76.96310348599991, -12.076566354999954],
    [-76.96537498599992, -12.078652354999974],
    [-76.96696098699988, -12.081105479999849],
    [-76.96756836099996, -12.081714854999973],
    [-76.96992561099995, -12.083296854999958],
    [-76.97293361099997, -12.083820354999943],
    [-76.97300973599994, -12.08350197999988],
    [-76.97333598599994, -12.082978479999895],
    [-76.97384961099993, -12.082050729999878],
    [-76.97388086099994, -12.081581978999907],
    [-76.97379298599992, -12.079326229999879],
    [-76.97441398599989, -12.077482479999901],
    [-76.97462111199997, -12.077650354999946],
    [-76.97475973699989, -12.077828104999924],
    [-76.9748437369999, -12.078044979999902],
    [-76.97487298599992, -12.078390604999925],
    [-76.97503873599999, -12.07870622999991],
    [-76.97625586199996, -12.078133228999945],
    [-76.97541011199996, -12.076451229999975],
    [-76.97449886099997, -12.07432885499992],
    [-76.97315436099996, -12.071410729999968],
    [-76.97252786099995, -12.070127353999851],
    [-76.97199611199994, -12.068826229999843],
    [-76.97187086099996, -12.068446729999948],
    [-76.97184373599993, -12.068323104999934],
    [-76.97167223699995, -12.067545229999894],
    [-76.97152911099994, -12.066869229999838],
    [-76.9712187369999, -12.066933604999917],
    [-76.97090236099996, -12.067027354999937],
    [-76.9706582359999, -12.067081978999852],
    [-76.97039848599991, -12.067128854999908],
    [-76.9701269869999, -12.067039103999946],
    [-76.96961723699991, -12.066792979999832],
    [-76.96808398699989, -12.065587729999947],
    [-76.9641649859999, -12.064082354999925],
    [-76.96086911099997, -12.062675729999967],
    [-76.95859398599993, -12.061876978999976],
    [-76.95390236099996, -12.06137885499993],
    [-76.95058198599997, -12.059917979999966],
    [-76.94432223599989, -12.056699229999936],
    [-76.94206636099995, -12.06066997999983],
    [-76.94118661099998, -12.062168354999926],
    [-76.94111548599989, -12.06228947999989],
    [-76.94006448599998, -12.064048854999953]
  ],
  // V1-D-119497 Miraflores
  [
    [-77.02655861099993, -12.108199229999911],
    [-77.02631048599994, -12.110349479999911],
    [-77.02614186099999, -12.111975854999912],
    [-77.02600386199998, -12.11348247999996],
    [-77.02596348599997, -12.114105479999921],
    [-77.02594923599997, -12.11432622999996],
    [-77.02615173599992, -12.116892354999948],
    [-77.02617573599997, -12.117197229999931],
    [-77.0261406109999, -12.117462854999872],
    [-77.02582736099998, -12.119121229999962],
    [-77.02582036099994, -12.119158229999925],
    [-77.02518748599994, -12.119175729999938],
    [-77.02491986199988, -12.1192694799999],
    [-77.02409573599982, -12.119841729999905],
    [-77.01823436199999, -12.119414104999976],
    [-77.01820811099992, -12.119414479999818],
    [-77.01820511099993, -12.11971485499987],
    [-77.01822173599999, -12.12009160499997],
    [-77.01824236199991, -12.120560479999938],
    [-77.01821286099988, -12.120560104999925],
    [-77.01727923599998, -12.120548854999981],
    [-77.01729486199997, -12.119435479999936],
    [-77.01380273699993, -12.11937885499998],
    [-77.01380273599995, -12.118822104999936],
    [-77.01324611099989, -12.1187929799999],
    [-77.0132538609999, -12.117867229999945],
    [-77.01319536199998, -12.117685604999963],
    [-77.01302923599997, -12.11752735499988],
    [-77.01016986199988, -12.115691354999967],
    [-77.00467523599985, -12.123680229999877],
    [-77.00258636099994, -12.12656185499992],
    [-77.00093748599994, -12.128945354999871],
    [-77.00163086099991, -12.128861354999856],
    [-77.00559173599999, -12.12829297999997],
    [-77.00955686099991, -12.127657729999896],
    [-77.00956836199998, -12.127785104999873],
    [-77.00958986199998, -12.128074229999925],
    [-77.00942973599996, -12.129910104999965],
    [-77.01130861199988, -12.130081979999943],
    [-77.01177148699998, -12.13000385499987],
    [-77.01187298599996, -12.130494104999968],
    [-77.01245898599996, -12.1303574799999],
    [-77.01257423599998, -12.130812479999975],
    [-77.01299411199989, -12.131261729999949],
    [-77.01318161099988, -12.130878854999878],
    [-77.0130586109999, -12.130204979999917],
    [-77.01309573599997, -12.129843729999948],
    [-77.01348448699997, -12.12995310499997],
    [-77.01373823599994, -12.129410104999977],
    [-77.01399811099992, -12.129482604999907],
    [-77.01436723599994, -12.129570354999885],
    [-77.01474223599996, -12.129591854999887],
    [-77.01519136099989, -12.129576229999941],
    [-77.01558198699996, -12.129540979999945],
    [-77.01571098599999, -12.129974604999973],
    [-77.01587698599997, -12.13019922899997],
    [-77.01616011099992, -12.129943354999853],
    [-77.01643361099991, -12.130539104999855],
    [-77.01712111199998, -12.129937479999967],
    [-77.01731636099993, -12.130111354999883],
    [-77.01731636099993, -12.130408228999954],
    [-77.01802348599995, -12.130421854999895],
    [-77.01799998699994, -12.131246104999889],
    [-77.01914848599995, -12.131269479999958],
    [-77.01945036099994, -12.130597354999963],
    [-77.01948398699989, -12.1306122299999],
    [-77.0196121109999, -12.130669104999924],
    [-77.02115623599997, -12.133251854999969],
    [-77.02127148699998, -12.133445354999878],
    [-77.02169923599996, -12.134070354999892],
    [-77.02210348599993, -12.134460979999972],
    [-77.0225058609999, -12.134714854999856],
    [-77.02311523599997, -12.134933604999901],
    [-77.02299611099994, -12.13526760499991],
    [-77.02404298599998, -12.135806604999857],
    [-77.02424998599997, -12.135878854999874],
    [-77.02456836199991, -12.135964854999884],
    [-77.02467773699993, -12.135986354999886],
    [-77.02489448599994, -12.136019479999959],
    [-77.02500586199989, -12.136035104999848],
    [-77.02511136099992, -12.136060604999898],
    [-77.02521673599995, -12.136093728999981],
    [-77.0253183609999, -12.136136729999976],
    [-77.02541598599998, -12.136185604999866],
    [-77.02551173599994, -12.136240229999942],
    [-77.02568361099992, -12.136374979999971],
    [-77.02581448699993, -12.136503854999887],
    [-77.02591986099992, -12.136650354999858],
    [-77.02598436199992, -12.136773479999931],
    [-77.02656048699998, -12.137783229999968],
    [-77.02667973599995, -12.137962854999898],
    [-77.02681048599999, -12.138140604999876],
    [-77.02709961099993, -12.138466854999876],
    [-77.02747461099995, -12.1388066049999],
    [-77.02762498599998, -12.13896485499987],
    [-77.02776173599995, -12.139134729999967],
    [-77.02788861099992, -12.139316354999892],
    [-77.02793948599998, -12.139415979999967],
    [-77.02818948599997, -12.139548854999873],
    [-77.02830273699993, -12.139626979999946],
    [-77.02845311199991, -12.139706979999971],
    [-77.02943748599995, -12.140140604999885],
    [-77.02954098699996, -12.140148479999937],
    [-77.02856636199988, -12.139689479999959],
    [-77.02851948599994, -12.139603478999959],
    [-77.02845698599998, -12.139531229999932],
    [-77.02841998599996, -12.13943748],
    [-77.02840823599996, -12.139333979999947],
    [-77.02842773599997, -12.139248104999922],
    [-77.02843548699997, -12.139164104999907],
    [-77.02844923599997, -12.139097604999904],
    [-77.02848636099992, -12.139025229999959],
    [-77.02856248599994, -12.138927729999978],
    [-77.02858411099993, -12.138871104999907],
    [-77.02861723599983, -12.13879885499989],
    [-77.02865623599996, -12.138720729999932],
    [-77.02866998599995, -12.138642604999916],
    [-77.0286933619999, -12.138548854999897],
    [-77.02870898599997, -12.138478479999947],
    [-77.02874223599997, -12.138398479999978],
    [-77.02879686099993, -12.138306604999855],
    [-77.02886911099995, -12.138224604999891],
    [-77.02892573599996, -12.138152353999942],
    [-77.0289628619999, -12.138103479999927],
    [-77.02899998699996, -12.138015604999907],
    [-77.02902536099992, -12.137906229999942],
    [-77.02905273599998, -12.137818354999865],
    [-77.02908198599994, -12.137757854999904],
    [-77.02913086099994, -12.137660104999895],
    [-77.02937498599982, -12.137740229999963],
    [-77.02939848699998, -12.137673854999889],
    [-77.02911523699998, -12.137544979999973],
    [-77.02909961099994, -12.137460979999958],
    [-77.02911323599994, -12.137392604999889],
    [-77.02915236099994, -12.137304729999926],
    [-77.02919723599996, -12.13721285499986],
    [-77.02924023599996, -12.137130854999896],
    [-77.02926373699995, -12.137052729999937],
    [-77.02929298599997, -12.136993979999943],
    [-77.02933986199992, -12.136910104999856],
    [-77.02936136099993, -12.136833979999949],
    [-77.02941011099995, -12.136720729999979],
    [-77.02945311099995, -12.136591729999964],
    [-77.02949023599996, -12.136509729999943],
    [-77.02953323599996, -12.136439479999979],
    [-77.02958986099992, -12.13633397999996],
    [-77.02965248599997, -12.136246104999884],
    [-77.02969923599983, -12.13612310499991],
    [-77.02974223599983, -12.136029354999891],
    [-77.02975986099995, -12.135974604999888],
    [-77.02979298599996, -12.135912104999875],
    [-77.02983786199991, -12.135845729999971],
    [-77.02992773599988, -12.13566210499988],
    [-77.03004098699995, -12.135499979999963],
    [-77.03015423699998, -12.135328104999871],
    [-77.03024223699998, -12.135160104999898],
    [-77.03038473599997, -12.134909979999918],
    [-77.03053711099994, -12.134718729999975],
    [-77.03069336199991, -12.13446873],
    [-77.03083986099995, -12.134287104999885],
    [-77.03093361099991, -12.134164104999911],
    [-77.03102736099993, -12.134027229999958],
    [-77.03114061099996, -12.133949229999928],
    [-77.03124798599998, -12.133849604999853],
    [-77.03132811099994, -12.133712854999885],
    [-77.03147073599996, -12.133585979999964],
    [-77.03165423699994, -12.133437479999941],
    [-77.0317636119999, -12.133298854999907],
    [-77.03191598599994, -12.13319722999995],
    [-77.03213086199992, -12.133085979999976],
    [-77.03237111199991, -12.132982479999953],
    [-77.03254298699994, -12.132804729999975],
    [-77.03268548599982, -12.132658229999947],
    [-77.03284173599997, -12.132505854999977],
    [-77.03317386099997, -12.132269479999934],
    [-77.03334373699994, -12.132158229999959],
    [-77.03344336099991, -12.132062479999945],
    [-77.03350386099993, -12.131999979999932],
    [-77.0336698619999, -12.13196685499986],
    [-77.03382623599998, -12.131910104999974],
    [-77.03399798599997, -12.131796854999891],
    [-77.03418161099995, -12.131716854999866],
    [-77.03439061099994, -12.131607479999957],
    [-77.03454686099991, -12.131488354999874],
    [-77.03467973599999, -12.13141797999998],
    [-77.03481636099991, -12.13125385499984],
    [-77.03492186199992, -12.131132854999862],
    [-77.03503123599995, -12.1310391049999],
    [-77.03519723599999, -12.130982479999943],
    [-77.03534373599996, -12.130906229999937],
    [-77.03545298599994, -12.130867229999978],
    [-77.03557611099995, -12.130863229999932],
    [-77.03568948699996, -12.130896479999933],
    [-77.03700186099991, -12.132773479999969],
    [-77.03711723599997, -12.132691479999949],
    [-77.03553911199992, -12.130437479999955],
    [-77.03558986099995, -12.130318354999872],
    [-77.0356621119999, -12.130181604999848],
    [-77.03577148599999, -12.130070479999972],
    [-77.03594723599997, -12.129919979999954],
    [-77.03611911099995, -12.129748104999862],
    [-77.03630473599998, -12.129597604999844],
    [-77.03643561099994, -12.129457104999858],
    [-77.03655073599998, -12.129357479999953],
    [-77.03668173599988, -12.12927535499989],
    [-77.0367968619999, -12.129195354999979],
    [-77.03690823599999, -12.129074229999958],
    [-77.03698436199988, -12.128955104999875],
    [-77.03710923599994, -12.128790979999962],
    [-77.03726561099995, -12.1287734799999],
    [-77.03726561099995, -12.128654479999966],
    [-77.03718361099993, -12.128613229999928],
    [-77.03708986099997, -12.128531229999965],
    [-77.03710348599998, -12.128415854999957],
    [-77.03718361099993, -12.12829297999997],
    [-77.03733598699995, -12.128130854999881],
    [-77.03745523699996, -12.127943354999843],
    [-77.03759761099991, -12.127773354999874],
    [-77.03765623599998, -12.12763672999995],
    [-77.03776761099994, -12.127525354999875],
    [-77.03798436099993, -12.127310604999877],
    [-77.03808011099994, -12.12718948],
    [-77.03824023699997, -12.127074229999948],
    [-77.03843161099996, -12.12694335499998],
    [-77.03851173699996, -12.126892604999853],
    [-77.03924023599984, -12.127648479999948],
    [-77.03934761099993, -12.1275429799999],
    [-77.03858786099994, -12.126757729999952],
    [-77.03854686099993, -12.126677854999912],
    [-77.03851173699996, -12.126607479999961],
    [-77.03851173599998, -12.126505854999891],
    [-77.03861136099994, -12.12633985499997],
    [-77.03875198599997, -12.12615435499987],
    [-77.03895323599988, -12.125953104999837],
    [-77.03909373599998, -12.1257909799999],
    [-77.03925586099996, -12.125632854999878],
    [-77.03941598599988, -12.125455104999844],
    [-77.03957811099997, -12.125294979999978],
    [-77.03964848599998, -12.12523047999997],
    [-77.03976761099995, -12.125113229999954],
    [-77.03989448599998, -12.125003854999875],
    [-77.04007423699994, -12.124902354999847],
    [-77.04031648599988, -12.124701229999971],
    [-77.04049611199991, -12.124556604999839],
    [-77.04059173699994, -12.124486229999945],
    [-77.04080273599999, -12.124441354999874],
    [-77.04104486099993, -12.124359354999967],
    [-77.04114461099994, -12.124320354999895],
    [-77.04121486099996, -12.124234354999885],
    [-77.04131636099993, -12.124193229999946],
    [-77.04141198599996, -12.124214854999877],
    [-77.04159961099992, -12.124410104999981],
    [-77.04168361099994, -12.124328104999961],
    [-77.04154298699996, -12.124148479999974],
    [-77.04164848599999, -12.123968729999945],
    [-77.04179098599997, -12.123828104999973],
    [-77.0420214859999, -12.123652354999876],
    [-77.04218161099993, -12.1235507299999],
    [-77.04230661099996, -12.123470603999976],
    [-77.04247261199993, -12.123435604999884],
    [-77.04252348699998, -12.1233964799999],
    [-77.04260348599996, -12.123359354999877],
    [-77.04274811099998, -12.123290979999922],
    [-77.04284573599989, -12.12324997899998],
    [-77.04301361199992, -12.123193354999842],
    [-77.04325198599997, -12.123122979999948],
    [-77.04336148699997, -12.12307422999993],
    [-77.04342386099995, -12.123019479999925],
    [-77.04346886199994, -12.122988229999919],
    [-77.04354686099992, -12.122947229999909],
    [-77.04362498599988, -12.122917979999954],
    [-77.04368748699994, -12.12289260499989],
    [-77.0437637359999, -12.122835979999934],
    [-77.04384173599988, -12.122794979999924],
    [-77.04391011199993, -12.12276560499987],
    [-77.0439804859999, -12.122708979999913],
    [-77.04404486099992, -12.12266210499996],
    [-77.04408986099997, -12.1226269799999],
    [-77.04415623599988, -12.1225859799999],
    [-77.04423048699982, -12.12252535499988],
    [-77.0443047359999, -12.122470729999918],
    [-77.04435548599997, -12.122429729999965],
    [-77.04441986099994, -12.122373104999895],
    [-77.04447661099994, -12.122314479999943],
    [-77.04453711099995, -12.122273479999933],
    [-77.0445781119999, -12.122216854999976],
    [-77.04463473599998, -12.122175729999924],
    [-77.04470111099994, -12.12213872999996],
    [-77.04476361099995, -12.12209373],
    [-77.04482811199995, -12.122044979999941],
    [-77.04489848599991, -12.12199610399989],
    [-77.04499998599988, -12.12189848],
    [-77.04506636099995, -12.12184760499997],
    [-77.04516011099997, -12.121777354999836],
    [-77.04523236099993, -12.1217304799999],
    [-77.04529886099994, -12.121679854999911],
    [-77.04535161099994, -12.121642604999977],
    [-77.04543548599997, -12.121587854999973],
    [-77.04551173599998, -12.121548854999844],
    [-77.04560936099995, -12.121511729999952],
    [-77.04566411099995, -12.121484354999836],
    [-77.04573048599985, -12.121476604999884],
    [-77.04579686099993, -12.121458979999943],
    [-77.04585548599988, -12.121456979999948],
    [-77.04593361099995, -12.121462854999834],
    [-77.04646673699995, -12.121992229999933],
    [-77.0465332359999, -12.121915978999937],
    [-77.04600773699997, -12.121382854999979],
    [-77.04604298599997, -12.121265604999962],
    [-77.04600773599998, -12.121177729999943],
    [-77.04593361099995, -12.121060604999968],
    [-77.04592573599984, -12.12096285499996],
    [-77.04586136199993, -12.1208749799999],
    [-77.04576948599998, -12.120816354999874],
    [-77.0457226119999, -12.120767604999969],
    [-77.0456992359999, -12.12070897999996],
    [-77.0456562359999, -12.120646479999948],
    [-77.04560548599989, -12.120613229999947],
    [-77.04556248599988, -12.120554729999924],
    [-77.04552348599998, -12.1204589799999],
    [-77.04553123599999, -12.120398479999949],
    [-77.04553911199991, -12.120320354999876],
    [-77.04555661099994, -12.12024410499987],
    [-77.04558786099994, -12.120156229999907],
    [-77.0456132359999, -12.12006835499983],
    [-77.04569536099996, -12.119968729999925],
    [-77.04575786199996, -12.11986522999996],
    [-77.04581836099993, -12.119792978999953],
    [-77.04584573599999, -12.119724604999874],
    [-77.04591011099996, -12.119679728999927],
    [-77.0459609859999, -12.119628854999974],
    [-77.04609573599998, -12.11950585499983],
    [-77.04626361099997, -12.119373104999966],
    [-77.04636323599988, -12.119283229999951],
    [-77.04648823599985, -12.119183604999876],
    [-77.04660736199992, -12.11908985499997],
    [-77.04670111199994, -12.11905472999996],
    [-77.04679098599985, -12.11900198],
    [-77.04684761099998, -12.118867229999921],
    [-77.0470097359999, -12.118751979999956],
    [-77.04710361099995, -12.118699229999947],
    [-77.04730861199994, -12.118572229999927],
    [-77.04745311099998, -12.118533229999912],
    [-77.04757811099995, -12.118478479999908],
    [-77.04763086099996, -12.11838672999994],
    [-77.04772848699997, -12.118314479999924],
    [-77.04788086199994, -12.118271479999919],
    [-77.04806836099993, -12.118203104999964],
    [-77.04831448699997, -12.118083979999938],
    [-77.04846486199995, -12.117984354999976],
    [-77.04861911099994, -12.117931604999967],
    [-77.04878723699989, -12.1178064799999],
    [-77.04889261099999, -12.117703104999975],
    [-77.04911136099997, -12.11757810499995],
    [-77.04927348599989, -12.117462854999872],
    [-77.04940423699998, -12.117347604999964],
    [-77.04954486199995, -12.11721285499982],
    [-77.04970111099993, -12.11709760499997],
    [-77.0498319859999, -12.11699810499988],
    [-77.04998823599988, -12.116884729999924],
    [-77.05014448599985, -12.116742229999943],
    [-77.05026948699998, -12.1166797299999],
    [-77.05033798699998, -12.1166797299999],
    [-77.05117386099994, -12.117496104999873],
    [-77.05126561099996, -12.117414103999863],
    [-77.0503632359999, -12.116523479999955],
    [-77.05032036099993, -12.116425729999946],
    [-77.05027536099993, -12.116330104999975],
    [-77.05025198599986, -12.11624022899997],
    [-77.05022661099997, -12.116171854999948],
    [-77.05020311099997, -12.116033229999914],
    [-77.05018548699996, -12.1159784799999],
    [-77.05020111099998, -12.11590623],
    [-77.05023036099993, -12.115816354999822],
    [-77.05025386199992, -12.115759729999922],
    [-77.05032223599989, -12.115636729999949],
    [-77.05035161199993, -12.115570354999875],
    [-77.0504062359999, -12.115494104999982],
    [-77.05045511199995, -12.11541597999991],
    [-77.05048048599991, -12.115361354999834],
    [-77.05049611099997, -12.115293104999978],
    [-77.05052736099998, -12.11524610499987],
    [-77.05055861099999, -12.115181604999975],
    [-77.05058986099993, -12.115123104999839],
    [-77.05063473599989, -12.1150547299999],
    [-77.0506777359999, -12.114978479999934],
    [-77.05074611099997, -12.114884729999915],
    [-77.05083398599999, -12.114792979999947],
    [-77.0509042359999, -12.11471685499987],
    [-77.05094336199994, -12.114677729999926],
    [-77.05099811199995, -12.114619104999974],
    [-77.05105073599998, -12.1145527299999],
    [-77.05110348699998, -12.11449222999994],
    [-77.05115823599988, -12.114404354999976],
    [-77.05122848699995, -12.114322229999914],
    [-77.05127923599997, -12.114257854999835],
    [-77.05138873599992, -12.114154354999869],
    [-77.05145911099999, -12.114070354999967],
    [-77.05155073599985, -12.11399410499996],
    [-77.05163673599986, -12.113912104999827],
    [-77.05176173699988, -12.113853479999932],
    [-77.05181448699989, -12.113808604999974],
    [-77.05186136099996, -12.113748104999956],
    [-77.05191986199992, -12.113685603999897],
    [-77.05200786099994, -12.113619104999941],
    [-77.05207436099994, -12.113572229999932],
    [-77.05213673599991, -12.113523479999913],
    [-77.05225586199992, -12.11342973],
    [-77.05236136099995, -12.113349604999826],
    [-77.05243561099996, -12.113281229999927],
    [-77.05252148599999, -12.11318360499996],
    [-77.05261523699988, -12.113078104999943],
    [-77.05274023599986, -12.11298047999992],
    [-77.05284173599989, -12.112945354999965],
    [-77.05289061199994, -12.112904354999955],
    [-77.05293948699989, -12.112841854999829],
    [-77.05299611099997, -12.112789104999877],
    [-77.05306636199992, -12.112740229999929],
    [-77.05314648599989, -12.112706979999928],
    [-77.05322848599991, -12.1126874799999],
    [-77.05329098599998, -12.112642604999962],
    [-77.05333186099995, -12.112564479999946],
    [-77.05336523599988, -12.112521479999941],
    [-77.05343161099995, -12.112474604999818],
    [-77.05348636099995, -12.112441354999817],
    [-77.05360936199992, -12.112386729999912],
    [-77.05367573599989, -12.112349604999963],
    [-77.05373823699995, -12.112322229999904],
    [-77.05385736099998, -12.112271479999947],
    [-77.05393161199993, -12.112230479999937],
    [-77.05398048599989, -12.112203104999821],
    [-77.05405861099996, -12.112150354999812],
    [-77.05414448699997, -12.112087729999871],
    [-77.05423236099995, -12.112035104999961],
    [-77.05429886199994, -12.111994104999951],
    [-77.05434961099996, -12.111972604999949],
    [-77.05441411099997, -12.111939479999933],
    [-77.05446098599992, -12.111908229999926],
    [-77.05451173699998, -12.111863229999926],
    [-77.05458011099995, -12.11180660499997],
    [-77.05466011199991, -12.111761729999898],
    [-77.05479298599988, -12.11172460499995],
    [-77.0548672359999, -12.111683604999826],
    [-77.05494536099997, -12.111617229999922],
    [-77.05500973699998, -12.111548854999967],
    [-77.05508598699998, -12.111503854999967],
    [-77.05516998699989, -12.111468729999899],
    [-77.05526361199992, -12.111437479999893],
    [-77.05533411199997, -12.111398479999934],
    [-77.05539261199993, -12.111371104999819],
    [-77.0554609859999, -12.111331979999932],
    [-77.05555273599987, -12.111271479999914],
    [-77.05562111099994, -12.111220728999967],
    [-77.0556757359999, -12.111183604999951],
    [-77.05573823599991, -12.1111484799999],
    [-77.05585348699998, -12.111099604999822],
    [-77.05591411099994, -12.111072104999948],
    [-77.05596673699995, -12.111019479999925],
    [-77.05574998599991, -12.110966729999916],
    [-77.05569336099995, -12.110941354999966],
    [-77.05558986099999, -12.110888729999942],
    [-77.0554158619999, -12.110812479999936],
    [-77.05534961099994, -12.1107812299999],
    [-77.05516011099996, -12.110693354999967],
    [-77.05507036099993, -12.11062110499995],
    [-77.05500786199997, -12.110566354999946],
    [-77.05497661099997, -12.11051760499987],
    [-77.05493948599991, -12.110445354999968],
    [-77.05495511199996, -12.110357479999948],
    [-77.05497261199991, -12.110289104999822],
    [-77.05497848599998, -12.110224604999814],
    [-77.05496486099997, -12.110154354999963],
    [-77.0549297359999, -12.110101604999954],
    [-77.05485736199995, -12.110039104999828],
    [-77.05478711199993, -12.11000585499994],
    [-77.05474023599999, -12.109978479999938],
    [-77.05469136099998, -12.109953104999818],
    [-77.05462498599991, -12.10990435499997],
    [-77.05455473599989, -12.109839854999962],
    [-77.05447461199992, -12.10976560499995],
    [-77.05441798699997, -12.109736354999825],
    [-77.05429286099996, -12.109699229999933],
    [-77.0537402359999, -12.10969335499982],
    [-77.05355661199991, -12.109640604999981],
    [-77.05350786099996, -12.109609354999975],
    [-77.0534257359999, -12.109537104999959],
    [-77.05334373599999, -12.109453104999943],
    [-77.05331448599992, -12.109398479999925],
    [-77.05326948599998, -12.109292979999907],
    [-77.0531992359999, -12.108959104999883],
    [-77.05315436099994, -12.108449229999906],
    [-77.05306448599987, -12.108542979999925],
    [-77.05288873599989, -12.108738229999915],
    [-77.05275786199996, -12.108882853999887],
    [-77.0525819859999, -12.10907810499998],
    [-77.05248436099998, -12.109187479999889],
    [-77.05236136099995, -12.10933010499997],
    [-77.05220511199997, -12.109501979999948],
    [-77.05208011099995, -12.109630854999978],
    [-77.05201173599988, -12.109697228999948],
    [-77.05196673599988, -12.10974997999989],
    [-77.05190436199996, -12.109816229999865],
    [-77.05186323599997, -12.10985935499997],
    [-77.05177348699988, -12.109953104999818],
    [-77.05169723599988, -12.110035104999952],
    [-77.05161723599991, -12.110121104999962],
    [-77.05152148699983, -12.110224604999814],
    [-77.05141986099994, -12.110331979999899],
    [-77.04926936099992, -12.108369104999952],
    [-77.04669136099994, -12.110941354999966],
    [-77.04618548599984, -12.110464854999975],
    [-77.04499811199992, -12.110449229999915],
    [-77.04415036199993, -12.110476604999974],
    [-77.04352348599986, -12.110654354999951],
    [-77.04311323599984, -12.110845729999937],
    [-77.04046286099992, -12.1083457299999],
    [-77.03994536099998, -12.108857479999926],
    [-77.03904098699996, -12.109753854999951],
    [-77.03824998599998, -12.108974604999958],
    [-77.03715823699997, -12.110064479999949],
    [-77.03661136199992, -12.110025354999948],
    [-77.03148823699996, -12.103550729999881],
    [-77.02732161199992, -12.102841979999937],
    [-77.02746673699994, -12.103595729999938],
    [-77.02746486099994, -12.105302354999935],
    [-77.02741986199999, -12.105966854999963],
    [-77.02731248599997, -12.10632035499998],
    [-77.02655861099993, -12.108199229999911]
  ],
  // V1-D-119502 San Isidro
  [
    [-77.06067428499995, -12.10767511399996],
    [-77.06034061599996, -12.10722806899986],
    [-77.05972195599986, -12.107055557999956],
    [-77.0605057399999, -12.106053310999926],
    [-77.06065371299997, -12.105836282999974],
    [-77.06030861199997, -12.10516797999992],
    [-77.06035548599988, -12.104652354999814],
    [-77.06051173599991, -12.104212854999957],
    [-77.06062498599988, -12.103728479999916],
    [-77.06062111199998, -12.103259729999877],
    [-77.06054298699985, -12.10296285499993],
    [-77.06066798599988, -12.102523479999888],
    [-77.06077936099996, -12.102132853999876],
    [-77.06074611099996, -12.101820354999973],
    [-77.06068361099994, -12.1014609799999],
    [-77.06057423599992, -12.101070354999933],
    [-77.0607949859999, -12.10094322999987],
    [-77.0602012359999, -12.099888729999918],
    [-77.05995111099998, -12.100021479999896],
    [-77.05948436099999, -12.099003854999978],
    [-77.05936911099997, -12.09862110499995],
    [-77.05838473699998, -12.096671854999954],
    [-77.05888286099997, -12.096404354999947],
    [-77.0573847359999, -12.092552729999909],
    [-77.05576761099996, -12.093386729999906],
    [-77.05498436099998, -12.091886729999885],
    [-77.05321686099995, -12.093070354999952],
    [-77.04990036099997, -12.08670310499997],
    [-77.04962311099996, -12.08624610499993],
    [-77.04908398599986, -12.085554729999899],
    [-77.04858598599986, -12.085040979999974],
    [-77.04761723699988, -12.091576229999873],
    [-77.04649411199995, -12.09142385499996],
    [-77.04645311199994, -12.091671854999959],
    [-77.04306248599988, -12.09120122999991],
    [-77.04317186099996, -12.090455103999943],
    [-77.03373436099992, -12.089169978999905],
    [-77.03346098599997, -12.090730479999877],
    [-77.02987886099993, -12.091189479999912],
    [-77.03016798699997, -12.091910229999883],
    [-77.02281236099992, -12.090810604999945],
    [-77.00982973599992, -12.089158854999937],
    [-77.00756973599988, -12.088829479999958],
    [-77.00756536099988, -12.088826979999965],
    [-77.00754686099987, -12.088955104999968],
    [-77.00755473599997, -12.089271479999866],
    [-77.00759186099992, -12.08950585499997],
    [-77.00769536099989, -12.089892604999932],
    [-77.01100198599994, -12.095978479999872],
    [-77.01211323599995, -12.099111354999934],
    [-77.01062111099992, -12.106683604999944],
    [-77.01044136099989, -12.107277354999951],
    [-77.0146913619999, -12.108040979999885],
    [-77.01498061099994, -12.107781229999887],
    [-77.01655273599994, -12.105568354999946],
    [-77.01647073699996, -12.10434760499993],
    [-77.01641798599996, -12.104142604999936],
    [-77.01611911099991, -12.103562354999951],
    [-77.0163261109999, -12.10342785499995],
    [-77.01643361099991, -12.103324229999885],
    [-77.01648636099992, -12.103222604999928],
    [-77.01651361099988, -12.103064479999887],
    [-77.01641211099991, -12.102296854999963],
    [-77.01876561099994, -12.101921854999944],
    [-77.02732161199992, -12.102841979999937],
    [-77.03148823699996, -12.103550729999881],
    [-77.03661136199992, -12.110025354999948],
    [-77.03715823699997, -12.110064479999949],
    [-77.03824998599998, -12.108974604999958],
    [-77.03904098699996, -12.109753854999951],
    [-77.03994536099998, -12.108857479999926],
    [-77.04046286099992, -12.1083457299999],
    [-77.04311323599984, -12.110845729999937],
    [-77.04352348599986, -12.110654354999951],
    [-77.04415036199993, -12.110476604999974],
    [-77.04499811199992, -12.110449229999915],
    [-77.04618548599984, -12.110464854999975],
    [-77.04669136099994, -12.110941354999966],
    [-77.04926936099992, -12.108369104999952],
    [-77.05141986099994, -12.110331979999899],
    [-77.05152148699983, -12.110224604999814],
    [-77.05161723599991, -12.110121104999962],
    [-77.05169723599988, -12.110035104999952],
    [-77.05177348699988, -12.109953104999818],
    [-77.05186323599997, -12.10985935499997],
    [-77.05190436199996, -12.109816229999865],
    [-77.05196673599988, -12.10974997999989],
    [-77.05201173599988, -12.109697228999948],
    [-77.05208011099995, -12.109630854999978],
    [-77.05220511199997, -12.109501979999948],
    [-77.05236136099995, -12.10933010499997],
    [-77.05248436099998, -12.109187479999889],
    [-77.0525819859999, -12.10907810499998],
    [-77.05275786199996, -12.108882853999887],
    [-77.05288873599989, -12.108738229999915],
    [-77.05306448599987, -12.108542979999925],
    [-77.05315436099994, -12.108449229999906],
    [-77.0531992359999, -12.108959104999883],
    [-77.05326948599998, -12.109292979999907],
    [-77.05331448599992, -12.109398479999925],
    [-77.05334373599999, -12.109453104999943],
    [-77.0534257359999, -12.109537104999959],
    [-77.05350786099996, -12.109609354999975],
    [-77.05355661199991, -12.109640604999981],
    [-77.0537402359999, -12.10969335499982],
    [-77.05429286099996, -12.109699229999933],
    [-77.05441798699997, -12.109736354999825],
    [-77.05447461199992, -12.10976560499995],
    [-77.05455473599989, -12.109839854999962],
    [-77.05462498599991, -12.10990435499997],
    [-77.05469136099998, -12.109953104999818],
    [-77.05474023599999, -12.109978479999938],
    [-77.05478711199993, -12.11000585499994],
    [-77.05485736199995, -12.110039104999828],
    [-77.0549297359999, -12.110101604999954],
    [-77.05496486099997, -12.110154354999963],
    [-77.05497848599998, -12.110224604999814],
    [-77.05497261199991, -12.110289104999822],
    [-77.05495511199996, -12.110357479999948],
    [-77.05493948599991, -12.110445354999968],
    [-77.05497661099997, -12.11051760499987],
    [-77.05500786199997, -12.110566354999946],
    [-77.05507036099993, -12.11062110499995],
    [-77.05516011099996, -12.110693354999967],
    [-77.05534961099994, -12.1107812299999],
    [-77.0554158619999, -12.110812479999936],
    [-77.05558986099999, -12.110888729999942],
    [-77.05569336099995, -12.110941354999966],
    [-77.05574998599991, -12.110966729999916],
    [-77.05596673699995, -12.111019479999925],
    [-77.05601761099996, -12.110966729999916],
    [-77.05608198599998, -12.110945354999956],
    [-77.05616211199992, -12.110874979999892],
    [-77.05622261199994, -12.110831854999958],
    [-77.05629098599991, -12.110753854999814],
    [-77.05640036099999, -12.11066985499997],
    [-77.0565097359999, -12.110617229999946],
    [-77.05657611199996, -12.110550729999886],
    [-77.05663086099997, -12.110501979999924],
    [-77.05666798599992, -12.1104472299999],
    [-77.05672661099999, -12.110390604999964],
    [-77.05677148699988, -12.110353479999901],
    [-77.05684173599991, -12.110302729999944],
    [-77.05690423599998, -12.1102519799999],
    [-77.05696473599988, -12.110201229999916],
    [-77.0570624859999, -12.110138729999903],
    [-77.05714261099996, -12.110089854999956],
    [-77.05723636099998, -12.110035104999952],
    [-77.05730661099994, -12.109999979999941],
    [-77.0574199859999, -12.109935603999872],
    [-77.05749798699998, -12.10985160499996],
    [-77.05755073599988, -12.109796854999956],
    [-77.05760723599997, -12.10974997999989],
    [-77.05766798699989, -12.109716854999874],
    [-77.05779311099997, -12.109656229999928],
    [-77.05786723699998, -12.109599604999971],
    [-77.05792186099995, -12.109548854999957],
    [-77.05800386199996, -12.109494229999939],
    [-77.05808011199997, -12.10944335499994],
    [-77.05815036099995, -12.109394479999935],
    [-77.0582089859999, -12.109339854999973],
    [-77.05827148599991, -12.1092734799999],
    [-77.05831448599992, -12.109238229999903],
    [-77.05836723599992, -12.109210979999943],
    [-77.05843361199993, -12.109165979999887],
    [-77.05854886199995, -12.109042979999913],
    [-77.05867186099994, -12.108949229999894],
    [-77.05879486099997, -12.108857479999926],
    [-77.05885736099998, -12.108810604999974],
    [-77.05892973599993, -12.108751979999909],
    [-77.05904686099996, -12.108710979999898],
    [-77.05913086099997, -12.10867385499995],
    [-77.05918548599999, -12.108638604999953],
    [-77.05923236099994, -12.108605479999937],
    [-77.05927736099994, -12.108564479999927],
    [-77.05935161099995, -12.108523479999917],
    [-77.05945511199997, -12.108470729999908],
    [-77.05953111199995, -12.108435604999954],
    [-77.05961911099996, -12.108384729999898],
    [-77.05969336099997, -12.108343729999888],
    [-77.05977348599993, -12.108312479999938],
    [-77.05985548599989, -12.108263854999848],
    [-77.05994336099997, -12.108212729999877],
    [-77.06000386099998, -12.108177729999909],
    [-77.06009573599988, -12.108123104999947],
    [-77.06015036199994, -12.108070354999825],
    [-77.06023048599991, -12.108003854999936],
    [-77.06038873599994, -12.107871104999958],
    [-77.06045511099995, -12.107826229999944],
    [-77.06051761099997, -12.10777735499994],
    [-77.06056836099998, -12.107730354999944],
    [-77.06063673599988, -12.107691354999929],
    [-77.06067428499995, -12.10767511399996]
  ],
  // V1-D-119508 Santiago de Surco

  [
    [-76.9592324869999, -12.075755854999954],
    [-76.9583124859999, -12.07594535499993],
    [-76.95794923599988, -12.07582047999989],
    [-76.95738861099994, -12.07604297999984],
    [-76.95705661099998, -12.076244104999944],
    [-76.95671673599998, -12.076562479999836],
    [-76.95638861099997, -12.076921854999966],
    [-76.9560917359999, -12.077287104999925],
    [-76.95575973599989, -12.077697229999842],
    [-76.95557036099996, -12.078003854999963],
    [-76.95551173699988, -12.078374979999978],
    [-76.95568148599989, -12.078439479999872],
    [-76.95603323699999, -12.078726604999929],
    [-76.95661948599997, -12.079104979999954],
    [-76.95732823599991, -12.079562353999961],
    [-76.95922873599994, -12.081662104999964],
    [-76.96007173699996, -12.08285747999986],
    [-76.96060348599991, -12.084246104999977],
    [-76.96088398599994, -12.08515647899992],
    [-76.96086873599995, -12.086474604999978],
    [-76.96030161099998, -12.090903854999908],
    [-76.95982648599994, -12.092712479999932],
    [-76.95909098599992, -12.09376310499988],
    [-76.9587536109999, -12.09424510499997],
    [-76.95824798699988, -12.095639729999903],
    [-76.95796873599988, -12.097324229999913],
    [-76.95726698599998, -12.0981226049999],
    [-76.95628611099994, -12.098720354999898],
    [-76.95555036199988, -12.0992874799999],
    [-76.95450823599998, -12.100360354999964],
    [-76.95404836099988, -12.100988729999926],
    [-76.95311348599989, -12.102122854999948],
    [-76.95204061099992, -12.103517604999979],
    [-76.95115173599993, -12.104391229999976],
    [-76.95076861099994, -12.105004229999963],
    [-76.9505846109999, -12.106536853999955],
    [-76.95038536099992, -12.107548354999892],
    [-76.94984898599995, -12.108759229999976],
    [-76.94908261099988, -12.109908729999972],
    [-76.94876073599988, -12.110935604999952],
    [-76.94857686099994, -12.112146354999936],
    [-76.94839298599993, -12.113525604999893],
    [-76.94808648699996, -12.115012354999976],
    [-76.94774611099996, -12.117535104999945],
    [-76.94777307199996, -12.117526533999921],
    [-76.94797258099999, -12.117463110999893],
    [-76.94810101599995, -12.117403560999946],
    [-76.94812759799999, -12.117391235999833],
    [-76.9481413499999, -12.117382300999964],
    [-76.94824370399994, -12.117315806999898],
    [-76.94837723799998, -12.117230689999872],
    [-76.9485667209999, -12.117085870999972],
    [-76.94868646599997, -12.1169759799999],
    [-76.94877720099993, -12.11688733699998],
    [-76.94883512199993, -12.11683144899996],
    [-76.94892384299999, -12.11673325399994],
    [-76.94899713699994, -12.116652385999885],
    [-76.94917503799996, -12.11651912799988],
    [-76.94933342799993, -12.116376440999886],
    [-76.94948351099993, -12.116272394999896],
    [-76.94958681099996, -12.116173778999894],
    [-76.94967332899989, -12.116093582999952],
    [-76.9497740679999, -12.11604389799993],
    [-76.94991048899999, -12.11598171799983],
    [-76.95003622299998, -12.115947161999884],
    [-76.95015114799992, -12.115923395999971],
    [-76.95026625099996, -12.115924116999963],
    [-76.95039094099997, -12.115959972999974],
    [-76.95064029899999, -12.116028622999977],
    [-76.95095024699998, -12.116087663999963],
    [-76.95114642499993, -12.116115362999949],
    [-76.95129571099994, -12.116111251999882],
    [-76.95149477699988, -12.1161083199999],
    [-76.95181171199994, -12.116058642999974],
    [-76.95201362199992, -12.116018958999973],
    [-76.95213939999996, -12.115990523999926],
    [-76.95226998899989, -12.115981951999913],
    [-76.95236470599991, -12.115959857999883],
    [-76.9525650039999, -12.115912531999982],
    [-76.95267208499996, -12.115879636999978],
    [-76.95276578099998, -12.115845269999909],
    [-76.95286514699995, -12.115820846999839],
    [-76.95294036699994, -12.11579123699994],
    [-76.95302281599993, -12.11573976699998],
    [-76.95313294199997, -12.115644289999977],
    [-76.9532402559999, -12.115563181999903],
    [-76.95331005599996, -12.115536862999875],
    [-76.95342959699991, -12.115533150999909],
    [-76.95354047399996, -12.115540978999945],
    [-76.95366011999982, -12.115551614999958],
    [-76.95384398499993, -12.115570407999883],
    [-76.95395773599995, -12.115572475999898],
    [-76.95415899299996, -12.11557679699996],
    [-76.95434256499988, -12.115555414999903],
    [-76.95471849899991, -12.11551832899994],
    [-76.9551995399999, -12.115497719999837],
    [-76.95544762299994, -12.115524667999921],
    [-76.95561436599996, -12.115595234999887],
    [-76.95571124699995, -12.115683512999908],
    [-76.95579369399996, -12.115791980999916],
    [-76.9559960169999, -12.115942648999976],
    [-76.95614249399995, -12.11603344699995],
    [-76.95628003499996, -12.116098479999891],
    [-76.95638553899988, -12.116169478999893],
    [-76.95648533699989, -12.116257735999909],
    [-76.95667284999996, -12.116376940999942],
    [-76.95687790199997, -12.11650176199987],
    [-76.95699838499996, -12.11662717899992],
    [-76.95711328699997, -12.116787072999955],
    [-76.95726339199996, -12.116975414999956],
    [-76.95733107099989, -12.117058158999896],
    [-76.95741635099995, -12.117155126999933],
    [-76.95747721899988, -12.117231627999956],
    [-76.9574958199999, -12.117255005999937],
    [-76.95760770199996, -12.117400571999895],
    [-76.95767271499989, -12.117517771999928],
    [-76.95773508499991, -12.11767229599991],
    [-76.95777981099997, -12.117806856999948],
    [-76.95779810299996, -12.117915776999894],
    [-76.95781358399995, -12.11803906599988],
    [-76.9579613819999, -12.118310644999951],
    [-76.95805983399998, -12.1186141399999],
    [-76.9581224349999, -12.118800228999874],
    [-76.95820882499993, -12.11904928499996],
    [-76.95840280199991, -12.119376092999914],
    [-76.95843184799992, -12.119425028999956],
    [-76.95849065899989, -12.119557959999952],
    [-76.95856922599995, -12.119667410999966],
    [-76.95875951199997, -12.119766505999962],
    [-76.95885434099989, -12.119773010999893],
    [-76.95897031699997, -12.119786602999966],
    [-76.95908703999999, -12.119796108999935],
    [-76.95917938399998, -12.119821857999966],
    [-76.9592786529999, -12.119837226999891],
    [-76.95937561299996, -12.119856055999946],
    [-76.95947504799989, -12.119894380999824],
    [-76.95953257499997, -12.11994448199988],
    [-76.95962163799999, -12.120000097999934],
    [-76.95969373299988, -12.120021780999878],
    [-76.95989165099991, -12.120021146999932],
    [-76.95997884899992, -12.120034304999933],
    [-76.96007571399997, -12.120093310999948],
    [-76.9602620249999, -12.120260349999967],
    [-76.96038585499997, -12.12039109799997],
    [-76.96052735299992, -12.120598246999975],
    [-76.96065580499999, -12.120722840999974],
    [-76.96074238199998, -12.120863800999928],
    [-76.96084106999996, -12.121065895999948],
    [-76.96095919999988, -12.12126785299995],
    [-76.96102241899996, -12.121405151999966],
    [-76.96110538699998, -12.12158440099995],
    [-76.96117663399991, -12.121756078999852],
    [-76.96128360299997, -12.12202698799996],
    [-76.96141776299999, -12.122293878999926],
    [-76.96144948399996, -12.122377832999973],
    [-76.96164235999998, -12.122697874999972],
    [-76.96172183199991, -12.122930715999871],
    [-76.96175391799989, -12.123064408999937],
    [-76.9617734709999, -12.123345501999893],
    [-76.96183317999999, -12.123534479999933],
    [-76.96191632399996, -12.123737640999934],
    [-76.9619492629999, -12.123855065999976],
    [-76.96227499599996, -12.124475483999959],
    [-76.96244034099993, -12.124891293999895],
    [-76.96252600099984, -12.125333872999931],
    [-76.96219763599993, -12.126747272999978],
    [-76.9622832959999, -12.127104191999933],
    [-76.96248317099992, -12.127304066999955],
    [-76.96955016999988, -12.131729863999965],
    [-76.97079850399996, -12.132249031999947],
    [-76.97091902499989, -12.133649124999977],
    [-76.97212435499989, -12.133920733999958],
    [-76.97214890099997, -12.13499932399992],
    [-76.97339749799988, -12.135131317999935],
    [-76.97394200299993, -12.135153696999907],
    [-76.97447993799994, -12.135226184999965],
    [-76.9744442459999, -12.135737768999945],
    [-76.97449449999988, -12.13589465399997],
    [-76.97474643699996, -12.136750229999961],
    [-76.9749475889999, -12.136915288999944],
    [-76.97544968699998, -12.137177957999882],
    [-76.97502138399994, -12.13805835799991],
    [-76.97508758699985, -12.138090211999952],
    [-76.9778697569999, -12.139114322999887],
    [-76.97880369599994, -12.139161912999896],
    [-76.9791427689999, -12.13901319599995],
    [-76.97923199899992, -12.138816890999976],
    [-76.97926174199989, -12.138620584999899],
    [-76.9793569199999, -12.138567046999981],
    [-76.9806358809999, -12.138400484999977],
    [-76.98075774399996, -12.138730778999957],
    [-76.98143679399999, -12.142707689999952],
    [-76.98190371999993, -12.145333466999944],
    [-76.98196427999994, -12.14567402699987],
    [-76.98204562599994, -12.146156505999897],
    [-76.98217135699991, -12.146724756999959],
    [-76.98228644599993, -12.147168731999898],
    [-76.98245017999983, -12.147617140999955],
    [-76.9830275089999, -12.149345806999918],
    [-76.98335757799993, -12.150330606999944],
    [-76.98353260099992, -12.150911320999967],
    [-76.98367767399998, -12.151595940999925],
    [-76.98374820999993, -12.152088252999818],
    [-76.98380645199995, -12.152600549999931],
    [-76.98383477999988, -12.153086532999907],
    [-76.98384504899997, -12.153488212999832],
    [-76.98383220099987, -12.154050281999957],
    [-76.98377411499996, -12.154739419999885],
    [-76.98369299699988, -12.155312010999921],
    [-76.98405021699995, -12.155743348999977],
    [-76.98423793899997, -12.155885484999942],
    [-76.9844487819999, -12.155998757999896],
    [-76.98478776099995, -12.156085283999971],
    [-76.98485604699994, -12.157510149999894],
    [-76.98493837799998, -12.160195424999927],
    [-76.98472905099999, -12.160204477999969],
    [-76.98470967799989, -12.16068969399987],
    [-76.98472536399998, -12.160945644999913],
    [-76.98451964499998, -12.161022983999942],
    [-76.98431654699988, -12.161167925999962],
    [-76.98424194999996, -12.161334901999965],
    [-76.98430524299994, -12.161609935999934],
    [-76.98432690799996, -12.162040230999821],
    [-76.98414641799991, -12.162480585999901],
    [-76.98378697099986, -12.162781611999947],
    [-76.98373973599996, -12.164015908999943],
    [-76.9842341829999, -12.165791551999973],
    [-76.98440794699997, -12.166452252999932],
    [-76.98493149999996, -12.166439452999839],
    [-76.98497955999994, -12.166439067999875],
    [-76.98510005899999, -12.166430548999813],
    [-76.98522839199984, -12.1664296269999],
    [-76.98539175299993, -12.166432278999935],
    [-76.9855200859999, -12.166431355999975],
    [-76.98561013099999, -12.166436815999873],
    [-76.98563292099999, -12.16643819799998],
    [-76.98574978599999, -12.166464140999835],
    [-76.98587071099996, -12.166513012999872],
    [-76.98597610799999, -12.166565821999882],
    [-76.98604664799996, -12.166638012999897],
    [-76.98613291399988, -12.16673304799997],
    [-76.98618406599996, -12.166813030999947],
    [-76.98625474899995, -12.166904351999847],
    [-76.98630575899989, -12.166965204999883],
    [-76.98634541499996, -12.167068226999902],
    [-76.98636227799994, -12.167244111999878],
    [-76.98636544199996, -12.167318562999924],
    [-76.98636699199989, -12.167355038999915],
    [-76.98639873799993, -12.167472944999815],
    [-76.9864442359999, -12.167886604999921],
    [-76.98649023699988, -12.168116479999924],
    [-76.98653173699995, -12.168861979999974],
    [-76.98664773599995, -12.169835104999947],
    [-76.98710036099999, -12.171199354999942],
    [-76.9880319859999, -12.172541854999906],
    [-76.98860073599997, -12.172905104999927],
    [-76.98934173599991, -12.173015604999932],
    [-76.98983198599996, -12.173097729999881],
    [-76.99056636099988, -12.173117229999889],
    [-76.99130073599991, -12.172585979999894],
    [-76.99163086099998, -12.172040979999963],
    [-76.99246098599997, -12.171273479999968],
    [-76.99372261099984, -12.170283229999882],
    [-76.99474223599998, -12.169652354999926],
    [-76.99551561099997, -12.169064479999975],
    [-76.99600386199995, -12.168634854999937],
    [-76.9971093609999, -12.167798854999944],
    [-76.9977266109999, -12.167263729999888],
    [-76.9981277359999, -12.167017604999955],
    [-76.99815311099997, -12.167005354999958],
    [-76.99898536199998, -12.166693104999865],
    [-76.99935336099998, -12.166693104999865],
    [-76.99950661099996, -12.166846354999905],
    [-76.99975786099986, -12.167349604999913],
    [-76.99993573699999, -12.167719979999902],
    [-77.00033398599999, -12.167867229999842],
    [-77.00095511099988, -12.169652354999926],
    [-77.00161723599996, -12.171560604999968],
    [-77.00202923599994, -12.172734354999932],
    [-77.00177148599994, -12.17290035499991],
    [-77.00229298599999, -12.174162104999937],
    [-77.00343548599994, -12.173830104999922],
    [-77.00459186099988, -12.173431604999962],
    [-77.00523236099986, -12.172415979999869],
    [-77.00568173599999, -12.171722604999957],
    [-77.00616798599998, -12.171097604999943],
    [-77.00688298599994, -12.170322229999954],
    [-77.00749611099991, -12.169675729999824],
    [-77.00749611099991, -12.169556604999912],
    [-77.00747273599995, -12.169246104999957],
    [-77.00781248599998, -12.168931604999955],
    [-77.00792973599994, -12.168732479999846],
    [-77.00821673699994, -12.16844535499996],
    [-77.00963086099989, -12.168046979999872],
    [-77.0096601109999, -12.16777347999988],
    [-77.01148036099988, -12.16659572999987],
    [-77.01202536099987, -12.166085979999878],
    [-77.01299798599996, -12.165195354999923],
    [-77.01296098699999, -12.165083979999963],
    [-77.0121738609999, -12.164576229999966],
    [-77.0119238609999, -12.164337854999928],
    [-77.01087111099991, -12.162916104999965],
    [-77.00969723599997, -12.161259604999884],
    [-77.00780661099986, -12.161456979999969],
    [-77.0074531109999, -12.160333979999962],
    [-77.0160351109999, -12.155628854999918],
    [-77.01584761099991, -12.155109354999922],
    [-77.01558398599997, -12.154734354999903],
    [-77.01635161099989, -12.154070229999945],
    [-77.01682811199998, -12.153685604999907],
    [-77.01715036199988, -12.153449229999978],
    [-77.0183516109999, -12.152628854999875],
    [-77.01735548599999, -12.150515729999825],
    [-77.01702536099992, -12.149718729999961],
    [-77.01595898599999, -12.147357479999812],
    [-77.01583011199989, -12.147287104999918],
    [-77.01576173599994, -12.147191354999904],
    [-77.01575198599994, -12.147089854999876],
    [-77.01519923599994, -12.147097604999885],
    [-77.01568948599999, -12.146505854999873],
    [-77.01388673599996, -12.14411322999996],
    [-77.01417961099992, -12.143863229999965],
    [-77.01409573699993, -12.1436972299999],
    [-77.01391998599996, -12.143259729999954],
    [-77.01382423699994, -12.143087854999862],
    [-77.01342386099992, -12.14227735499992],
    [-77.01260336099989, -12.140603479999982],
    [-77.0124863609999, -12.14043160499989],
    [-77.01384573599995, -12.13924610499987],
    [-77.01787298599999, -12.135763604999852],
    [-77.01799998699994, -12.131246104999889],
    [-77.01802348599995, -12.130421854999895],
    [-77.01731636099993, -12.130408228999954],
    [-77.01731636099993, -12.130111354999883],
    [-77.01712111199998, -12.129937479999967],
    [-77.01643361099991, -12.130539104999855],
    [-77.01616011099992, -12.129943354999853],
    [-77.01587698599997, -12.13019922899997],
    [-77.01571098599999, -12.129974604999973],
    [-77.01558198699996, -12.129540979999945],
    [-77.01519136099989, -12.129576229999941],
    [-77.01474223599996, -12.129591854999887],
    [-77.01436723599994, -12.129570354999885],
    [-77.01399811099992, -12.129482604999907],
    [-77.01373823599994, -12.129410104999977],
    [-77.01348448699997, -12.12995310499997],
    [-77.01309573599997, -12.129843729999948],
    [-77.0130586109999, -12.130204979999917],
    [-77.01318161099988, -12.130878854999878],
    [-77.01299411199989, -12.131261729999949],
    [-77.01257423599998, -12.130812479999975],
    [-77.01245898599996, -12.1303574799999],
    [-77.01187298599996, -12.130494104999968],
    [-77.01177148699998, -12.13000385499987],
    [-77.01130861199988, -12.130081979999943],
    [-77.00942973599996, -12.129910104999965],
    [-77.00958986199998, -12.128074229999925],
    [-77.00956836199998, -12.127785104999873],
    [-77.00955686099991, -12.127657729999896],
    [-77.00559173599999, -12.12829297999997],
    [-77.00163086099991, -12.128861354999856],
    [-77.00093748599994, -12.128945354999871],
    [-77.00258636099994, -12.12656185499992],
    [-77.00210998699998, -12.125949979999916],
    [-77.00159998599997, -12.125429979999979],
    [-77.00089048599995, -12.124469229999875],
    [-76.99999998699991, -12.1230399799999],
    [-76.99991636099992, -12.122976229999892],
    [-76.99961998599991, -12.122749854999938],
    [-76.99947998599998, -12.122469979999948],
    [-76.99932998599996, -12.122369979999917],
    [-76.99908861099993, -12.121820229999912],
    [-76.99905998599996, -12.121759979999979],
    [-76.99826998699996, -12.120579979999945],
    [-76.99811823599998, -12.120474729999955],
    [-76.99777998699989, -12.120240104999937],
    [-76.99754023599996, -12.11998572999994],
    [-76.99744998599994, -12.119889979999812],
    [-76.99731998699997, -12.119389979999937],
    [-76.99702811099996, -12.118672479999873],
    [-76.99642711099995, -12.11739035499994],
    [-76.99609561099999, -12.116690979999873],
    [-76.99583686099999, -12.116130104999911],
    [-76.99545986099997, -12.115319979999981],
    [-76.99503998699993, -12.11428997899992],
    [-76.9945799869999, -12.113399979999883],
    [-76.99420998599993, -12.112439979999976],
    [-76.99361723699991, -12.111321604999887],
    [-76.9927477359999, -12.111286604999918],
    [-76.98280086099999, -12.110583104999876],
    [-76.97828498599989, -12.11026422999987],
    [-76.9781659869999, -12.11025585499982],
    [-76.97903361099992, -12.1042583549999],
    [-76.97931986099991, -12.102061354999933],
    [-76.98011623599996, -12.09692460499997],
    [-76.98061711099996, -12.093379228999936],
    [-76.98107448699994, -12.090141479999886],
    [-76.98125973599991, -12.088830104999943],
    [-76.98160548599992, -12.087118354999973],
    [-76.98169336099983, -12.086683604999962],
    [-76.98178323599996, -12.085099604999982],
    [-76.98169136199994, -12.084628854999949],
    [-76.98137111099999, -12.084089854999945],
    [-76.98059486099999, -12.083297479999942],
    [-76.97967823599998, -12.082609729999945],
    [-76.97964973599994, -12.082609729999945],
    [-76.97844536199995, -12.081470729999978],
    [-76.97823311099995, -12.081208854999943],
    [-76.97748436099994, -12.080285229999902],
    [-76.97675386099996, -12.07903322999988],
    [-76.97625586199996, -12.078133228999945],
    [-76.97503873599999, -12.07870622999991],
    [-76.97487298599992, -12.078390604999925],
    [-76.9748437369999, -12.078044979999902],
    [-76.97475973699989, -12.077828104999924],
    [-76.97462111199997, -12.077650354999946],
    [-76.97441398599989, -12.077482479999901],
    [-76.97379298599992, -12.079326229999879],
    [-76.97388086099994, -12.081581978999907],
    [-76.97384961099993, -12.082050729999878],
    [-76.97333598599994, -12.082978479999895],
    [-76.97300973599994, -12.08350197999988],
    [-76.97293361099997, -12.083820354999943],
    [-76.96992561099995, -12.083296854999958],
    [-76.96756836099996, -12.081714854999973],
    [-76.96696098699988, -12.081105479999849],
    [-76.96537498599992, -12.078652354999974],
    [-76.96310348599991, -12.076566354999954],
    [-76.96189448599989, -12.076044979999892],
    [-76.96040236199997, -12.075706979999836],
    [-76.9592324869999, -12.075755854999954]
  ]
];

export { UBPECoordinates };
